import { calendar_week } from "./Calendar_Week";

export class calendar_month {
  public weeks: calendar_week[];
}
